

export const soraExamples = {
    title: 'Sora 2 影片生成範例 — 強大效果一覽',
    sub: '了解 Sora 2 如何將靜態圖片與文字描述轉化為具備進階物理模擬與電影質感的真實影片',
    imageToVideo: '圖片轉影片 — 為照片賦予動態',
    imageToVideoDesc: '上傳任何靜態圖片，讓 Sora 2 以自然運動賦予生命，同時維持視覺一致性與物理真實感。圖片轉影片模式保留原始美感，並加入順暢、貼近真實世界物理的動態效果。',
    originalImage: '原始圖片',
    generatedVideo: 'Sora 2 生成影片',
    pill: 'Sora 2',
    textToVideo: '文字轉影片 — 從文字到電影場景',
    textToVideoDesc: '用文字描述你的願景，Sora 2 會精準依照指示生成具專業品質的影片。文字轉影片模式理解複雜提示（包含運鏡、光線、動作與風格），幫你創作符合期待的內容。',
    promptLabel: '文字提示',
    promptText: '「好萊塢風格的分手場景，黃昏時分的寧靜郊區街道。三十多歲的男女相對而立，低聲但情緒充沛地對話。唇形與分手對話同步。電影級打光、溫暖的夕陽色調、淺景深、微風拂動秋葉、真實自然聲音，無背景音樂」'
  };
